import type { DiagramGender } from "../types/chart";

import manChestNeck from "../preset-images/Man - Chest & Neck.png";
import manFaceFrontal from "../preset-images/Man - Face - Frontal.png";
import manFaceLeft from "../preset-images/Man - Face - Left.png";
import manFaceRight from "../preset-images/Man - Face - Right.png";
import manFullBodyBack from "../preset-images/Man - Full Body - Back.png";
import manFullBodyFrontal from "../preset-images/Man - Full Body - Frontal.png";
import manLowerBody from "../preset-images/Man - Lower Body.png";
import womanChestNeck from "../preset-images/Woman - Chest & Neck.png";
import womanFaceFrontal from "../preset-images/Woman - Face - Frontal.png";
import womanFaceLeft from "../preset-images/Woman - Face - Left.png";
import womanFaceRight from "../preset-images/Woman - Face - Right.png";
import womanFullBodyBack from "../preset-images/Woman - Full Body - Back.png";
import womanFullBodyFrontal from "../preset-images/Woman - Full Body - Frontal.png";
import womanLowerBody from "../preset-images/Woman - Lower Body.png";

/**
 * Authoritative mapping from bundled preset images to tags.
 * Filenames are not parsed at runtime — add or edit rows here when assets or
 * tagging rules change. Extra tags (e.g. clinical use cases) can be added without
 * renaming files.
 */
export interface DiagramPresetCatalogEntry {
  /** Stable id for selection and saved chart references. */
  id: string;
  imageUrl: string;
  gender: DiagramGender;
  /**
   * Primary body-area label: drives default display name and filter chip for this view.
   */
  bodyPart: string;
  /**
   * All tags for this image. Include gender (`male` / `female`) and body-area
   * strings; add more for multi-tag filtering later.
   */
  tags: string[];
  /** Optional card title; defaults to `bodyPart`. */
  name?: string;
}

export const DIAGRAM_PRESET_CATALOG: DiagramPresetCatalogEntry[] = [
  {
    id: "male-chest-neck",
    imageUrl: manChestNeck,
    gender: "male",
    bodyPart: "Chest & Neck",
    tags: ["male", "Chest & Neck"],
  },
  {
    id: "male-face-frontal",
    imageUrl: manFaceFrontal,
    gender: "male",
    bodyPart: "Face - Frontal",
    tags: ["male", "Face - Frontal", "Face"],
  },
  {
    id: "male-face-left",
    imageUrl: manFaceLeft,
    gender: "male",
    bodyPart: "Face - Left",
    tags: ["male", "Face - Left", "Face"],
  },
  {
    id: "male-face-right",
    imageUrl: manFaceRight,
    gender: "male",
    bodyPart: "Face - Right",
    tags: ["male", "Face - Right", "Face"],
  },
  {
    id: "male-full-body-back",
    imageUrl: manFullBodyBack,
    gender: "male",
    bodyPart: "Full Body - Back",
    tags: ["male", "Full Body - Back", "Full body"],
  },
  {
    id: "male-full-body-frontal",
    imageUrl: manFullBodyFrontal,
    gender: "male",
    bodyPart: "Full Body - Frontal",
    tags: ["male", "Full Body - Frontal", "Full body"],
  },
  {
    id: "male-lower-body",
    imageUrl: manLowerBody,
    gender: "male",
    bodyPart: "Lower Body",
    tags: ["male", "Lower Body"],
  },
  {
    id: "female-chest-neck",
    imageUrl: womanChestNeck,
    gender: "female",
    bodyPart: "Chest & Neck",
    tags: ["female", "Chest & Neck"],
  },
  {
    id: "female-face-frontal",
    imageUrl: womanFaceFrontal,
    gender: "female",
    bodyPart: "Face - Frontal",
    tags: ["female", "Face - Frontal", "Face"],
  },
  {
    id: "female-face-left",
    imageUrl: womanFaceLeft,
    gender: "female",
    bodyPart: "Face - Left",
    tags: ["female", "Face - Left", "Face"],
  },
  {
    id: "female-face-right",
    imageUrl: womanFaceRight,
    gender: "female",
    bodyPart: "Face - Right",
    tags: ["female", "Face - Right", "Face"],
  },
  {
    id: "female-full-body-back",
    imageUrl: womanFullBodyBack,
    gender: "female",
    bodyPart: "Full Body - Back",
    tags: ["female", "Full Body - Back", "Full body"],
  },
  {
    id: "female-full-body-frontal",
    imageUrl: womanFullBodyFrontal,
    gender: "female",
    bodyPart: "Full Body - Frontal",
    tags: ["female", "Full Body - Frontal", "Full body"],
  },
  {
    id: "female-lower-body",
    imageUrl: womanLowerBody,
    gender: "female",
    bodyPart: "Lower Body",
    tags: ["female", "Lower Body"],
  },
];
